import { request } from "../core/request";

export function get(
  uri: string,
  params?: Record<string, string | number | boolean | undefined | string[] | number[]>,
  options?: RequestInit,
) {
  if (!options) {
    options = {};
  }
  options.method = "GET";
  const queryParts = [uri];
  if (params) {
    const paramsParts = Object.keys(params).map((key) => {
      return `${key}=${params[key]}`;
    });
    queryParts.push(paramsParts.join("&"));
  }
  return request(queryParts.join("?"), options);
}

export async function getJSON<T>(
  uri: string,
  params?: Record<string, string | number | boolean | undefined | string[] | number[]>,
  options?: RequestInit,
): Promise<T> {
  if (!options) {
    options = {};
  }
  if (!options.headers ) {
    options.headers  = {};
  }
  options.headers!['Accept'] = "application/json";
  const res = await get(uri, params, options);
  return await res.json();
}

export async function getText(
  uri: string,
  params?: Record<string, string | number | boolean | undefined | string[] | number[]>,
  options?: RequestInit,
) {
  const res = await get(uri, params, options);
  return await res.text();
}
